import React from "react";
import "./index.css";
import { BackButton } from "../backButton";

export const ForbiddenPage = () => {
  return (
    <div className={"forbidden"}>
      <div className={"statusCode"}>403</div>
      <div className={"tips"}>Unauthorized action.</div>
      <BackButton />
    </div>
  );
};
